import { createContext, useCallback, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import { api, type Counters } from "./api";
import { useAuth } from "./auth";

const EMPTY: Counters = { pending_by_entity: {}, expenses_to_process: 0, unread_messages: 0 };

interface Ctx {
  counters: Counters;
  refresh: () => Promise<void>;
}

const CountersCtx = createContext<Ctx>({ counters: EMPTY, refresh: async () => {} });

export function CountersProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [counters, setCounters] = useState<Counters>(EMPTY);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const r = await api<Counters>("/counters");
      setCounters(r);
    } catch {
      /* silencieux : pastilles non bloquantes */
    }
  }, [user]);

  useEffect(() => {
    if (!user) {
      setCounters(EMPTY);
      return;
    }
    refresh();
    const t = setInterval(refresh, 30_000); // toutes les 30s
    return () => clearInterval(t);
  }, [user, refresh]);

  return <CountersCtx.Provider value={{ counters, refresh }}>{children}</CountersCtx.Provider>;
}

export function useCounters() {
  return useContext(CountersCtx);
}
